import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core'

@Component({
  selector: 'setup-confirm',
  templateUrl: './setup-confirm.component.html',
  styleUrls: ['./setup-confirm.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetupConfirmComponent {
  @Output() next = new EventEmitter()

  @Input() title: string
  @Input() iconName: string
  @Input() confirmationText: string
  @Input() confirmationIconName: string
  @Input() nextButtonText: string
}
